import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import dayjs from 'dayjs';
import { DateFormat } from '/@/modules/core/app/constants/date.constants';
import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { User } from '@/modules/user/models/User';
import { Estate } from '@/modules/estate/models/Estate';
import { Address } from '@/modules/address/models/Address';
import { Contact } from '@/modules/contact/models/Contact';
import { Document } from '@/modules/document/models/Document';
import { Liability } from '@/modules/liability/models/Liability';
import { EstateAccount } from '@/modules/estateaccount/models/EstateAccount';
import { EstateForm } from '@/modules/estate/models/EstateForm';
import { GuidanceStep } from '@/modules/guidancestep/models/GuidanceStep';
import { Asset } from '@/modules/asset/models/Asset';
import { FinancialAccountTransaction } from '@/modules/financialaccount/models/FinancialAccountTransaction';

export class Audit extends BaseEntityModel {
  id?: number;
  event?: string;
  oldValues?: Record<string, unknown>;
  newValues?: Record<string, unknown>;
  userId?: string;
  auditableType?: string;
  auditableId?: string;
  user?: Relationship<User> | null;
  estate?: Relationship<Estate> | null;
  address?: Relationship<Address> | null;
  auditableUser?: Relationship<User> | null;
  auditableEstate?: Relationship<Estate> | null;
  contact?: Relationship<Contact> | null;
  document?: Relationship<Document> | null;
  liability?: Relationship<Liability> | null;
  estateAccount?: Relationship<EstateAccount> | null;
  estateForm?: Relationship<EstateForm> | null;
  guidanceStep?: Relationship<GuidanceStep> | null;
  asset?: Relationship<Asset> | null;
  financialAccountTransaction?: Relationship<FinancialAccountTransaction> | null;

  constructor(model: Partial<Audit> = {}) {
    super(model);

    this.id = model.id;
    this.event = model.event;
    this.oldValues = model.oldValues;
    this.newValues = model.newValues;
    this.userId = model.userId;
    this.auditableType = model.auditableType;
    this.auditableId = model.auditableId;

    this.estate = Estate.mapModelOrNull(model.estate);
    this.user = User.mapModelOrNull(model.user);
    this.address = Address.mapModelOrNull(model.address);
    this.auditableEstate = Estate.mapModelOrNull(model.auditableEstate);
    this.auditableUser = User.mapModelOrNull(model.auditableUser);
    this.asset = Asset.mapModelOrNull(model.asset);
    this.contact = Contact.mapModelOrNull(model.contact);
    this.document = Document.mapModelOrNull(model.document);
    this.estateAccount = EstateAccount.mapModelOrNull(model.estateAccount);
    this.estateForm = EstateForm.mapModelOrNull(model.estateForm);
    this.financialAccountTransaction = FinancialAccountTransaction.mapModelOrNull(
      model.financialAccountTransaction
    );
    model.liability = Liability.mapModelOrNull(model.liability);
  }

  getModelName(): ModelType {
    return ModelType.AUDIT;
  }

  get formattedCreatedAt(): string {
    return dayjs(this.createdAt).format(DateFormat.MONTH_DAY_WITH_ORDINAL_TWELVE_HOUR);
  }
}
